import React, { useCallback, useEffect } from 'react';
import { useOpenIssueTransitionModal } from '@atlassian/jira-issue-transition-trigger/src/utils/use-trigger-issue-transition-modal/index.tsx';
import { type Ari, createAri } from '@atlassian/jira-platform-ari';
import { useCloudId } from '@atlassian/jira-tenant-context-controller/src/components/cloud-id/index.tsx';
import { useBacklogDispatch, useBacklogSelector } from '../../../state';
import { closeIssueTransitionModal } from '../../../state/actions/issue-transition';
import {
	getHandlersForIssueTransitionModal,
	getPayloadForIssueTransitionModal,
	isIssueTransitionModalOpen,
} from '../../../state/selectors/issue-transition';

export const IssueTransitionModal = () => {
	const dispatch = useBacklogDispatch();
	const openIssueTransitionModal = useOpenIssueTransitionModal();
	const onClose = useCallback(() => {
		dispatch(closeIssueTransitionModal());
	}, [dispatch]);

	const isOpen = useBacklogSelector((state) => isIssueTransitionModalOpen(state));
	const {
		issueId = '',
		issueKey = '',
		transitionId = '',
	} = useBacklogSelector((state) => getPayloadForIssueTransitionModal(state));
	const { onDialogSuccess, onDialogCancel, onDialogError } = useBacklogSelector((state) =>
		getHandlersForIssueTransitionModal(state),
	);

	const cloudId = useCloudId();
	const ariIssueId: Ari = createAri({
		resourceOwner: 'jira',
		resourceType: 'issue',
		cloudId,
		resourceId: `${issueId}`,
	});

	useEffect(() => {
		if (isOpen) {
			const handleDialogCancel = () => {
				onDialogCancel?.();
				onClose();
			};
			const handleDialogError = (error?: Error) => {
				onDialogError?.(error);
				onClose();
			};
			const handleDialogSuccess = () => {
				onDialogSuccess?.();
				onClose();
			};
			openIssueTransitionModal({
				payload: { issueId: ariIssueId, issueKey, transitionId },
				triggerPointKey: 'issue-transition-board-card-transition',
				onDialogSuccess: handleDialogSuccess,
				onDialogCancel: handleDialogCancel,
				onDialogError: handleDialogError,
			});
		}
	}, [
		ariIssueId,
		isOpen,
		issueKey,
		onClose,
		onDialogCancel,
		onDialogError,
		onDialogSuccess,
		openIssueTransitionModal,
		transitionId,
	]);
	return <></>;
};

export default IssueTransitionModal;
